/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames not based on template
/******/ 			if (chunkId === "vendors.b475b500") return "" + chunkId + ".d2305007e7dc6d77a38b.js";
/******/ 			if (chunkId === "vendors.5fa6df7e") return "" + chunkId + ".1009bbaaf299eb6be243.js";
/******/ 			if (chunkId === "vendors.d1214f89") return "" + chunkId + ".87301587a982f242e3cc.js";
/******/ 			if (chunkId === "vendors.403ed072") return "" + chunkId + ".b1ad473e244e095df8d5.js";
/******/ 			if (chunkId === "vendors.4e91333c") return "" + chunkId + ".e5dcb1eeff9ebbff1b69.js";
/******/ 			if (chunkId === "vendors.213fe6e9") return "" + chunkId + ".48e05c7d511582631216.js";
/******/ 			if (chunkId === "vendors.f175e0c6") return "" + chunkId + ".3740e29d336e32579f50.js";
/******/ 			if (chunkId === "vendors.f0a15c9d") return "" + chunkId + ".4cc064c5ce5bd9a4bfaa.js";
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + "." + {"sections.top-bar":"0e1e7e30a5fb26bf4895","vendors.4b51a813":"9c16b9f30baca64b845d","vendors.bf80fe96":"e9d3aa561dc31da4a252","vendors.8d3bbaaf":"41caa015908b0879f7ec","sections.media-slider":"3a3e93400c9c5310460a","sections.advantages":"49e99a9866e5f60561f3","vendors.07b3d7ba":"ea157f22de8da885ce79","vendors.469d0024":"b8ae642e82b2b0b9c0ff","sections.collection-slider":"a834a2b086fecb634d03","sections.collection-with-filter":"af5402f99add5388ee64","local-vendors.62ba3a3d":"4e79a518c61213692dce","sections.dynamic-rewards":"8e8d64d8522e3554b2fa","sections.promo-grid":"a1084843cbf05a5354fb","sections.link-slider":"c7cbb5bbd8cf3cdee18e","local-vendors.9e743c70":"5f6df0fd789fcc32273c","sections.list-collections":"b26c9bd3cf3ae4952980","sections.creeping-line":"0edaf550259045e570a4","local-vendors.403ed072":"ab6f69a8c60c1cf0730e","sections.product-promo":"63aa23451cf44971d491","sections.accessories":"3bd6590aa161418b356c","sections.animated-image":"27e5d58922d3b5a58728","sections.background-video":"adc421bacf237b4bfdc8","sections.badged-info":"2ab8196234155561e9d1","sections.badged-slider":"c79d10b24a3a9c954230","sections.bg-video-text-icons":"60704cf429eb2d196b8f","sections.column-slider":"05cd2e137c31624d9206","sections.crowdfunding-line":"d27541e829e75a2b449d","sections.discover-products":"4eeebe0fd2db8f2eb933","sections.heading-text-video":"3309d7b81070da0e4947","sections.hero-image-with-promo":"fedfa44cab50cf77110f","sections.icons-image":"70bb45ab26d0eb28447a","sections.icons-text-video":"92185236cd0fee3f55d8","sections.icons-with-text":"d3877ac9551c0a9f905c","sections.image-compare":"e73b20bdeed4fb70be3e","sections.image-text":"8da1972eba10986a218a","sections.image-slider-left-align":"6d6fe73a64a400058447","sections.image-slider":"909d1f3730f5393952fb","sections.info-tabs":"09b5f39926735dabd0d8","sections.info-with-images":"7a58efa849d863a87922","sections.page-accordion":"c78a13c4fb906beea81b","sections.page":"6a68d3a5443d7376c280","sections.page-hero":"7136e9de2c9135826f7f","sections.parallax":"8f68783dc8b97146493d","sections.presentation":"413fcc0b5fe168752eb3","local-vendors.7a1bd3a4":"54652a5669321cdfbce3","sections.product":"7fa892b0bf2c072e538b","sections.product-compare":"f167f992e91a7b2e0bc6","sections.product-details":"21118358d987c7813b77","sections.product-heading-with-video":"d7e53ab42223dec93891","sections.promo-code":"6d4752ab69d08184e34a","sections.promo-content-with-icons":"b15dd1a7932a1c16057f","vendors.4ff030f0":"2b0fb15a3ae5c3f03fd3","sections.related-products":"c785553b99e631c7c583","sections.reviews":"8cac6e8acd7e965737eb","sections.rewards":"b9025a1d222595cd8f87","sections.rich-content-stickers":"870581879b940ca2ce28","sections.side-video-text":"c076c22b46f8feac2d4f","sections.steps":"e580716538e173f4dff2","sections.tabs-with-columns":"29b7d6c4d8397ee4723c","sections.tabs-with-sliders":"b94c9f8e731c1a43dc79","sections.video-with-info":"0de0ca3f06e5348391a2","sections.video-text-icons":"4350bfd6a11da77f740d","sections.404":"60a3a789fff6cc3cde93"}[chunkId] + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference all chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + "." + {"layout.checkout":"cb016a057f87392e842b","layout.gift-card":"a98e342fe4ac844417e8","local-vendors.49c9b602":"09116b2258eabe3cffdf","layout.theme":"e474cbf4a24fa5fcf88a","local-vendors.943b27ff":"ea37dc199b32d5ac404c","template.article":"8bf4907b012cd42e2dd9","template.blog":"382d8b984f5a17d427cc","template.collection.all-terrain-ss21":"cde69ccdec2ecb88d813","template.collection":"1ed06c3f06627704f656","template.list-collections":"746da1b18854f4e13620","template.page":"55635ace2d88c36646ef","template.product.alternative":"cf3db166cd46902e4b83","template.product":"0aacddc9043818c96a40","template.search":"985f940cb8bce046b2e1","template.customers.account":"687b20420dac94aac89a","template.customers.activate_account":"68d79534181110483bf8","template.customers.addresses":"c6efcac8b01626c9dee6","template.customers.login":"68d79534181110483bf8","template.customers.order":"d4d5b4c206276cf5a14e","template.customers.register":"68d79534181110483bf8","template.customers.reset_password":"68d79534181110483bf8","sections.top-bar":"c051fb3616e6b9bc01f2","sections.media-slider":"0c30622255222efc8ba8","sections.advantages":"56faa597b8a23c730330","sections.collection-slider":"43956521acebd0288490","sections.collection-with-filter":"8337077a7ebd7fa09619","sections.dynamic-rewards":"982a5f19cc1a813b3749","sections.promo-grid":"feb40cf5dae2a9f1fbac","sections.link-slider":"103e7d015147a3d5e83a","sections.list-collections":"907521f65a6c668cc6b8","sections.creeping-line":"3aa3de0f4f6ec305668e","sections.product-promo":"056f65861a27b77c3b0e","sections.accessories":"0a1de245451da24155de","sections.animated-image":"9d8359631e89e80d1b50","sections.background-video":"1ec94de42d5ac5970e78","sections.badged-info":"3ffefc0f84dfd89b2449","sections.badged-slider":"e89c99bed9f40f98d23e","sections.bg-video-text-icons":"d82344d691c5993eab13","sections.column-slider":"4b3940b3827bfa58bc3d","sections.crowdfunding-line":"9415c09e1b6689bae1b9","sections.discover-products":"b81568d3b31f6538815c","sections.heading-text-video":"9f3878a5e9d71b02e487","sections.hero-image-with-promo":"922771613131b16e2807","sections.icons-image":"d54a2ffa6e82fd229159","sections.icons-text-video":"3b7af627914665cfb7a1","sections.icons-with-text":"0aab5ba8fcf88c6e772d","sections.image-compare":"21d80218d9db61375a4e","sections.image-text":"173b0e902cfce08e3258","sections.image-slider-left-align":"395b290abf23837caf6d","sections.image-slider":"a83d50e34d3e7acae2ff","sections.info-tabs":"a65c79ef4c71b9b53438","sections.info-with-images":"06e33e18d4c6a8d55028","sections.page-accordion":"cf93852d7f570d618fd7","sections.page":"988e143f87fd68d75433","sections.page-hero":"3b6ab5c0858f2aa20438","sections.parallax":"464f7bf35d2a1a43fbb7","sections.presentation":"2bb12378d7ecd598a359","sections.product":"866ca59d956330988f11","sections.product-compare":"82f672b542e03fe67170","sections.product-details":"86e695a370185d94f5c7","sections.product-heading-with-video":"7f7dfe05f3f31dd26b08","sections.promo-code":"0440c4523f2bf889620c","sections.promo-content-with-icons":"4fdd9adbac0d4d86d748","sections.related-products":"d6f18c0bbe454e3b013a","sections.reviews":"f3b9d96cac5c6133d197","sections.rewards":"064eea66479a0fb18ddf","sections.rich-content-stickers":"bb6e990a40d6eed9b18b","sections.side-video-text":"53214be1f181da398122","sections.steps":"2b2ad3a0cd6175525ba3","sections.tabs-with-columns":"345ea7d1361ec6732ae5","sections.tabs-with-sliders":"b664bcd7121c6e294639","sections.video-with-info":"2bae84892b483ec2f492","sections.video-text-icons":"a9d84cae2207a5e7dfed","sections.404":"9c454201a10ac381ed85"}[chunkId] + ".css";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@spurit/tropicfeel-kw-new-theme:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) scriptUrl = scripts[scripts.length - 1].src
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/css loading */
/******/ 	(() => {
/******/ 		var createStylesheet = (chunkId, fullhref, resolve, reject) => {
/******/ 			var linkTag = document.createElement("link");
/******/ 		
/******/ 			linkTag.rel = "stylesheet";
/******/ 			linkTag.type = "text/css";
/******/ 			var onLinkComplete = (event) => {
/******/ 				// avoid mem leaks.
/******/ 				linkTag.onerror = linkTag.onload = null;
/******/ 				if (event.type === 'load') {
/******/ 					resolve();
/******/ 				} else {
/******/ 					var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 					var realHref = event && event.target && event.target.href || fullhref;
/******/ 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
/******/ 					err.code = "CSS_CHUNK_LOAD_FAILED";
/******/ 					err.type = errorType;
/******/ 					err.request = realHref;
/******/ 					linkTag.parentNode.removeChild(linkTag)
/******/ 					reject(err);
/******/ 				}
/******/ 			}
/******/ 			linkTag.onerror = linkTag.onload = onLinkComplete;
/******/ 			linkTag.href = fullhref;
/******/ 		
/******/ 			document.head.appendChild(linkTag);
/******/ 			return linkTag;
/******/ 		};
/******/ 		var findStylesheet = (href, fullhref) => {
/******/ 			var existingLinkTags = document.getElementsByTagName("link");
/******/ 			for(var i = 0; i < existingLinkTags.length; i++) {
/******/ 				var tag = existingLinkTags[i];
/******/ 				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
/******/ 				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
/******/ 			}
/******/ 			var existingStyleTags = document.getElementsByTagName("style");
/******/ 			for(var i = 0; i < existingStyleTags.length; i++) {
/******/ 				var tag = existingStyleTags[i];
/******/ 				var dataHref = tag.getAttribute("data-href");
/******/ 				if(dataHref === href || dataHref === fullhref) return tag;
/******/ 			}
/******/ 		};
/******/ 		var loadStylesheet = (chunkId) => {
/******/ 			return new Promise((resolve, reject) => {
/******/ 				var href = __webpack_require__.miniCssF(chunkId);
/******/ 				var fullhref = __webpack_require__.p + href;
/******/ 				if(findStylesheet(href, fullhref)) return resolve();
/******/ 				createStylesheet(chunkId, fullhref, resolve, reject);
/******/ 			});
/******/ 		}
/******/ 		// object to store loaded CSS chunks
/******/ 		var installedCssChunks = {
/******/ 			"runtime": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.miniCss = (chunkId, promises) => {
/******/ 			var cssChunks = {"sections.top-bar":1,"sections.media-slider":1,"sections.advantages":1,"sections.collection-slider":1,"sections.collection-with-filter":1,"sections.dynamic-rewards":1,"sections.promo-grid":1,"sections.link-slider":1,"sections.list-collections":1,"sections.creeping-line":1,"sections.product-promo":1,"sections.accessories":1,"sections.animated-image":1,"sections.background-video":1,"sections.badged-info":1,"sections.badged-slider":1,"sections.bg-video-text-icons":1,"sections.column-slider":1,"sections.crowdfunding-line":1,"sections.discover-products":1,"sections.heading-text-video":1,"sections.hero-image-with-promo":1,"sections.icons-image":1,"sections.icons-text-video":1,"sections.icons-with-text":1,"sections.image-compare":1,"sections.image-text":1,"sections.image-slider-left-align":1,"sections.image-slider":1,"sections.info-tabs":1,"sections.info-with-images":1,"sections.page-accordion":1,"sections.page":1,"sections.page-hero":1,"sections.parallax":1,"sections.presentation":1,"sections.product":1,"sections.product-compare":1,"sections.product-details":1,"sections.product-heading-with-video":1,"sections.promo-code":1,"sections.promo-content-with-icons":1,"sections.related-products":1,"sections.reviews":1,"sections.rewards":1,"sections.rich-content-stickers":1,"sections.side-video-text":1,"sections.steps":1,"sections.tabs-with-columns":1,"sections.tabs-with-sliders":1,"sections.video-with-info":1,"sections.video-text-icons":1,"sections.404":1};
/******/ 			if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
/******/ 			else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
/******/ 				promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
/******/ 					installedCssChunks[chunkId] = 0;
/******/ 				}, (e) => {
/******/ 					delete installedCssChunks[chunkId];
/******/ 					throw e;
/******/ 				}));
/******/ 			}
/******/ 		};
/******/ 		
/******/ 		// no hmr
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"runtime": 0,
/******/ 			"local-vendors.943b27ff": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(!/^(local\-vendors\.943b27ff|runtime|sections\.product)$/.test(chunkId)) {
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] = globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	
/******/ })()
;